import { toast, Toaster } from 'react-hot-toast';

export default function MessageToster(type, message, options = {}) {
    let cleanMessage = message;
    if (message && typeof message === 'object') {
        cleanMessage = message.message || message.msg || message.error || JSON.stringify(message);
    }
    if (!cleanMessage) return;

    const messageString = typeof cleanMessage === 'object' ? JSON.stringify(cleanMessage) : String(cleanMessage);

    // Normalize toast ID to prevent duplicate toasts for the same message
    let toastId = options.id;
    if (!toastId) {
        if (/session\s*expired/i.test(messageString)) {
            toastId = "session_expired_alert";
        } else {
            toastId = messageString.trim().toLowerCase();
        }
    }

    if (type === 'success') {
        toast.success(cleanMessage, { id: toastId, position: "top-right", duration: 3000, ...options });
        return;
    }
    if (type === 'error') {
        if (!options.force) {
            // Only suppress generic empty table/list messages like "No data found", "No records found"
            const noDataRegex = /^(?:no|zero)\s+(?:\w+\s+){0,2}(?:data|records?|transactions?|tickets?|trades?|history)\s+found\.?$/i;

            const isSuppressed = messageString.trim().toLowerCase() === "empty" || noDataRegex.test(messageString.trim());

            if (isSuppressed) {
                console.log("Suppressed error toast:", cleanMessage);
                return;
            }
        }

        toast.error(cleanMessage, {
            id: toastId,
            position: "top-right",
            duration: 4000,
            style: { zIndex: 99999 },
            ...options
        });
        return;
    }
    if (type === 'warn') {
        toast(cleanMessage, { id: toastId, icon: "⚠️", position: "top-right", duration: 3000, ...options });
        return;
    }
    if (type === 'info') {
        toast(cleanMessage, { id: toastId, icon: "ℹ️", position: "top-right", duration: 3000, ...options });
        return;
    }
    return <Toaster />;
}